import React from 'react';
import {
  Box, Typography, Paper,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'firebaseHooks/AuthContext';
import SignIn from 'components/auth/SignIn';
import useGlobal from 'global-state/store';

export default function SignInPage() {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [, globalActions] = useGlobal();

  React.useEffect(() => {
    if (currentUser) {
      navigate('/', { replace: true });
    }
  }, [navigate, currentUser]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        mt: 2,
        mb: 15,
      }}
    >
      <SignIn
        signinCallback={() => globalActions.setUserStatus('initial')}
      />
      <Typography variant="h5" component="div" sx={{ mt: 5 }}>
        {t('welcome.welcome_title')}
      </Typography>
      <Paper elevation={0} sx={{ p: 3, mb: 5 }}>
        <Typography component="p">{t('welcome.welcome_text')}</Typography>
      </Paper>
    </Box>
  );
}
